// Build-time feature flags (Vite env). Off unless explicitly enabled at build time.

/** Paid SCORM downloads from the AI builder: pricing copy stays hidden until checkout exists. */
export const SCORM_DOWNLOAD_PRICING = import.meta.env.VITE_SCORM_DOWNLOAD_PRICING === 'true';
